<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 433.57 433.57">
  <circle style="fill: currentColor" cx="216.78" cy="351.62" r="40.24"/>
  <path
    d="M216.77 351.62l142.16 0c13.59,0 22.34,-14.3 16.17,-26.43 -17.66,-34.72 -44.85,-99.6 -44.85,-169.75 0,-72.99 -68.94,-129.91 -145.28,-109.15 -49.3,13.4 -81.34,59.89 -81.69,110.98 -0.47,69.45 -27.35,133.55 -44.85,167.97 -6.11,12.08 2.64,26.37 16.19,26.37l142.14 0.01z"/>
</svg>
